import { lazy, Suspense } from 'react';
import { BrowserRouter, StaticRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Seo from './components/Seo';
import './assets/css/index.css'

const AboutUs = lazy(() => import('./pages/AboutUs'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const DataProtection = lazy(() => import('./pages/DataProtection'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const Faq = lazy(() => import('./pages/Faq'));
const SharedRecipe = lazy(() => import('./pages/SharedRecipe'));
const RecipeBook = lazy(() => import('./pages/RecipeBook'));
const RecipeBookDetail = lazy(() => import('./pages/RecipeBookDetail'));
const NotFound = lazy(() => import('./pages/NotFound'));

const PageFallback = () => (
    <div className="page-fallback" role="status" aria-live="polite">
        در حال بارگذاری…
    </div>
);

const App = ({ location = '/', initialData = null }) => {
    const isServer = typeof window === 'undefined';
    const Router = isServer ? StaticRouter : BrowserRouter;
    const routerProps = isServer ? { location } : {};

    return (
        <Router {...routerProps}>
            <Seo initialData={initialData} />
            <Suspense fallback={<PageFallback />}>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path="about" element={<AboutUs />} />
                        <Route path="contact" element={<ContactUs />} />
                        <Route path="privacy" element={<DataProtection />} />
                        <Route path="terms" element={<TermsOfService />} />
                        <Route path="faq" element={<Faq />} />
                        <Route path="sh/:token" element={<SharedRecipe initialData={initialData?.sharedRecipe} />} />
                        <Route path="recipes" element={<RecipeBook initialData={initialData?.recipeBook} />} />
                        <Route path="recipes/category/:categorySlug" element={<RecipeBook initialData={initialData?.recipeBook} />} />
                        <Route path="recipes/:slug" element={<RecipeBookDetail initialData={initialData?.recipeBook} />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </Suspense>
        </Router>
    );
};

export default App;
